import { render } from "./ReturnOrderRequestComponent.vue?vue&type=template&id=336a2fd4"
import script from "./ReturnOrderRequestComponent.vue?vue&type=script&lang=js"
export * from "./ReturnOrderRequestComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/account/returnOrders/ReturnOrderRequestComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "336a2fd4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('336a2fd4', __exports__)) {
    api.reload('336a2fd4', __exports__)
  }
  
  module.hot.accept("./ReturnOrderRequestComponent.vue?vue&type=template&id=336a2fd4", () => {
    api.rerender('336a2fd4', render)
  })

}


export default __exports__